import React from 'react';
import styled from 'styled-components';
import { useMatches, useSearchParams } from 'react-router-dom';

import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

import { parseSort, parseStatus } from '../utils/api';
import { makeHelpers } from '../utils/format';
import { usePolyEvents } from './usePolyEvents';

type PolyPredictionsEventsProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const PolyPredictionsEvents = (componentProps: PolyPredictionsEventsProps) => {
  let props = componentProps;
  let isVisible = true;

  const dataElementContext = React.useContext(DataElementContext);
  [props, isVisible] = processComponentProps(props, dataElementContext);

  const uriMatches = useMatches();
  const [searchParams] = useSearchParams();

  let slugId: string | undefined = 'trending';
  if (props.properties?.slugId) {
    slugId = props.properties.slugId;
  }

  if (props.properties?.hasTargetId && props.properties?.targetIdFromPath && props.properties?.pathParamKey) {
    if (uriMatches && uriMatches.length) {
      const match = uriMatches[0];
      let slugIdFromPath = props.properties.pathParamKey;
      if (slugIdFromPath[0] === ':') slugIdFromPath = slugIdFromPath.substr(1);
      if (match.params && slugIdFromPath && match.params[slugIdFromPath] != null) {
        slugId = match.params[slugIdFromPath];
      }
    }
  }

  const sort = parseSort(searchParams.get('sort'));
  const status = parseStatus(searchParams.get('status'));
  const search = searchParams.get('search') ?? '';

  const { events, liveByTokenId, hasMore, isLoading, isLoadingMore, error, loadMore } = usePolyEvents({
    sort,
    status,
    slugId,
    search,
  });

  const helpers = React.useMemo(() => makeHelpers(liveByTokenId), [liveByTokenId]);

  const contextValue = React.useMemo(
    () => ({
      slugId,
      sort,
      status,
      search,
      events,
      liveByTokenId,
      hasMore,
      isLoading,
      isLoadingMore,
      error,
      loadMore,
      helpers,
      parentContext: dataElementContext,
    }),
    [
      slugId,
      sort,
      status,
      search,
      events,
      liveByTokenId,
      hasMore,
      isLoading,
      isLoadingMore,
      error,
      loadMore,
      helpers,
      dataElementContext,
    ],
  );

  if (!isVisible) return null;

  console.log('PolyPredictionsEvents[contextValue]', contextValue);

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default PolyPredictionsEvents;
